import React, { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Col,
  Row,
  Button
} from "../../components/Component";
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames";
import KeywordsTable from "./components/keywords/KeywordsTable";
import TopicsTable from "./components/topics/TopicsTable";

const BlogKeywordsTopics = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <React.Fragment>
      <Head title="Blog Keywords & Topics" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Blog Keywords & Topics</BlockTitle>
              <BlockDes className="text-soft">
                Manage keywords and topics for your blog content
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Card className="card-bordered">
            <div className="card-aside-wrap">
              <div className="card-inner card-inner-lg">
                <Nav tabs className="nav-tabs-s1 px-0">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggleTab("1")}
                    >
                      <Icon name="tag" className="me-1" /> Keywords
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggleTab("2")}
                    >
                      <Icon name="list" className="me-1" /> Topics
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="mt-4">
                  <TabPane tabId="1">
                    <KeywordsTable />
                  </TabPane>
                  <TabPane tabId="2">
                    <TopicsTable />
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </Card>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default BlogKeywordsTopics;
